class Zepter_V2_Tooltips {
    constructor() {
        //console.log(this.elWithTooltips)
        this.elWithTooltips = document.body.querySelectorAll("[data-tooltip]");
        this.tooltipDefaults = {
            position: "bottom",
            forcePosition: false,
            dontUsePosition: [],
            arrowSize: 5,
            gap: 5,
            fontSize: "0.75em",
            backgroundColor: "black",
            textColor: "white",
            padding: { top: 5, bottom: 5, left: 10, right: 10 },
            borderRadius: 4,
            shadow: 3,
            shadowColor: "rgba(255, 255, 255, 0.75)",
            animationDuration: 100
        };
        // Jeśli brak elementów z tooltipami
        if (this.elWithTooltips.length === 0) {
            // Przerwij działanie klasy
            return;
        }
        // Dodaj tooltipy do funkcji w menu
        this.renderTooltips();
    }
    renderTooltips() {
        // Przetwarzaj elementy z tooltipami
        this.elWithTooltips.forEach((elWithTooltip) => {
            if (elWithTooltip.nodeType == 1 && !elWithTooltip.getAttribute("class").match(/mobile/i)) {
                // Stwórz objekt tooltipa
                this.renderTooltip(elWithTooltip);
            }
        });
    }
    renderTooltip(tooltipTarget) {
        // Jeśli brakuje danych o tooltipie
        if (!tooltipTarget.dataset.tooltip) {
            // Przerwij tę metodę
            return;
        }
        // Przetwórz dane tooltipa ze string na json
        var tooltipJsonData = {};
        try {
            tooltipJsonData = JSON.parse(tooltipTarget.dataset.tooltip);
        }
        catch (e) {
            console.warn(`[tooltip dataset json error]`, tooltipTarget, e);
            tooltipJsonData = null;
        }
        // Jeśli nie udało się przetworzyć string na json
        if (tooltipJsonData === null) {
            // przerwij tę metodę
            return;
        }
        // Ustal propsy dla tooltipa i połącz je z defaultowymi propsami dla tooltipa
        let tooltip = Object.assign(Object.assign({}, this.tooltipDefaults), tooltipJsonData);
        // Dodaj to [tooltip] cel, który ma być powiązany z tooltipem
        tooltip.target = tooltipTarget;
        // Jeśli brakuje labela
        if (!tooltip.label || tooltip.label && tooltip.label.length === 0) {
            // Przerwij tę metodę
            return;
        }
        // Dodaj do [tooltip] element, w którym bedzie się on znajdował (tooltip body)
        tooltip.element = document.createElement("div");
        // Dodaj elementy do DOM
        document.body.appendChild(tooltip.element);
        // Konfiguruj elementy
        tooltip.target.style.position = "relative";
        tooltip.element.innerText = tooltip.label;
        tooltip.element.style.display = "none";
        tooltip.element.style.opacity = "0";
        tooltip.element.style.position = "absolute";
        tooltip.element.style.zIndex = "9999";
        tooltip.element.style.whiteSpace = "nowrap";
        tooltip.element.style.fontSize = tooltip.fontSize;
        tooltip.element.style.backgroundColor = tooltip.backgroundColor;
        tooltip.element.style.color = tooltip.textColor;
        tooltip.element.style.paddingTop = `${tooltip.padding.top}px`;
        tooltip.element.style.paddingRight = `${tooltip.padding.right}px`;
        tooltip.element.style.paddingBottom = `${tooltip.padding.bottom}px`;
        tooltip.element.style.paddingLeft = `${tooltip.padding.left}px`;
        tooltip.element.style.borderRadius = `${tooltip.borderRadius}px`;
        tooltip.element.style.filter = `drop-shadow(${tooltip.shadowColor} 0px 0px ${tooltip.shadow}px)`;
        tooltip.element.style.transitionProperty = "opacity";
        tooltip.element.style.transitionDuration = `${tooltip.animationDuration / 1000}s`;
        tooltip.element.style.transitionTimingFunction = "ease-out";
        // Zdarzenie [mouseenter]
        const fnMouseEnter = (e) => {
            if (!e.target.dataset.tooltip) {
                return;
            }
            // Pokaż [tooltip]
            //console.log(`[over]  ${tooltip.label}`)
            this.showTooltip(tooltip);
        };
        // Zdarzenie [mouseleave]
        const fnMouseLeave = (e) => {
            if (!e.target.dataset.tooltip) {
                return;
            }
            // Ukryj [tooltip]
            //console.log(`[out]  ${tooltip.label}`)
            this.hideTooltip(tooltip);
        };
        // Obsłga zdarzeń
        tooltip.target.addEventListener("mouseenter", fnMouseEnter);
        tooltip.target.addEventListener("mouseleave", fnMouseLeave);
        window.addEventListener("Zepter_V2_Tooltips_Hide", () => { this.hideTooltip(tooltip); });
        window.addEventListener("scroll", () => { this.hideTooltip(tooltip); });
    }
    renderArrow(tooltip) {
        const arrow = document.createElement("div");
        if (tooltip.arrow) {
            tooltip.arrow.remove();
        }
        tooltip.arrow = arrow;
        tooltip.element.appendChild(arrow);
        // Konfiguruj strzałkę
        arrow.style.position = "absolute";
        //arrow.style.boxShadow = `0 0 0 ${tooltip.borderInsideWidth} ${tooltip.borderInsideColor}`
        arrow.style.width = `${tooltip.arrowSize * 2}px`;
        arrow.style.height = `${tooltip.arrowSize * 2}px`;
        arrow.style.backgroundColor = tooltip.backgroundColor;
        arrow.style.transformOrigin = "center";
        arrow.style.transform = "rotate(45deg)";
        if (tooltip.position == "top") {
            arrow.style.bottom = `-${tooltip.arrowSize}px`;
            arrow.style.left = `calc(50% - (${tooltip.arrowSize * 2}px / 2))`;
        }
        else if (tooltip.position == "bottom") {
            arrow.style.top = `-${tooltip.arrowSize}px`;
            arrow.style.left = `calc(50% - (${tooltip.arrowSize * 2}px / 2))`;
        }
        else if (tooltip.position == "left") {
            arrow.style.top = `calc(50% - (${tooltip.arrowSize * 2}px / 2))`;
            arrow.style.right = `-${tooltip.arrowSize}px`;
        }
        else if (tooltip.position == "right") {
            arrow.style.top = `calc(50% - (${tooltip.arrowSize * 2}px / 2))`;
            arrow.style.left = `-${tooltip.arrowSize}px`;
        }
        return arrow;
    }
    getElOffset(el) {
        const rect = el.getBoundingClientRect();
        return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY
        };
    }
    getElDimension(el) {
        return {
            width: el.offsetWidth,
            height: el.offsetHeight
        };
    }
    getTooltipPosition(tooltip, iteration = 0) {
        tooltip.coordinates = {
            x: 0,
            y: 0
        };
        const getCenterH = () => {
            return this.getElOffset(tooltip.target).left - (this.getElDimension(tooltip.element).width - this.getElDimension(tooltip.target).width) / 2;
        };
        const getCenterV = () => {
            return this.getElOffset(tooltip.target).top - (this.getElDimension(tooltip.element).height - this.getElDimension(tooltip.target).height) / 2;
        };
        if (tooltip.position == "top") {
            tooltip.coordinates.x = getCenterH();
            tooltip.coordinates.y = this.getElOffset(tooltip.target).top - this.getElDimension(tooltip.element).height - tooltip.arrowSize - tooltip.gap;
        }
        else if (tooltip.position == "bottom") {
            tooltip.coordinates.x = getCenterH(),
                tooltip.coordinates.y = this.getElOffset(tooltip.target).top + this.getElDimension(tooltip.target).height + tooltip.arrowSize + tooltip.gap;
        }
        else if (tooltip.position == "left") {
            tooltip.coordinates.x = this.getElOffset(tooltip.target).left - this.getElDimension(tooltip.element).width - tooltip.arrowSize - tooltip.gap;
            tooltip.coordinates.y = getCenterV();
        }
        else if (tooltip.position == "right") {
            tooltip.coordinates.x = this.getElOffset(tooltip.target).left + this.getElDimension(tooltip.target).width + tooltip.arrowSize + tooltip.gap;
            tooltip.coordinates.y = getCenterV();
        }
        //console.log(this.checkOverflow(tooltip))
        // If position of tooltip forced
        if (tooltip.forcePosition) {
            return tooltip; // Return tooltip standard position without auto positioning
        }
        if (iteration <= 3) {
            if (this.checkOverflow(tooltip).top) {
                if (typeof tooltip.dontUsePosition == "string" && tooltip.dontUsePosition !== "bottom"
                    || typeof tooltip.dontUsePosition == "object" && tooltip.dontUsePosition.indexOf("bottom") >= 0) {
                    tooltip.position = "bottom";
                }
                tooltip = this.getTooltipPosition(tooltip, iteration + 1);
            }
            else if (this.checkOverflow(tooltip).bottom) {
                if (typeof tooltip.dontUsePosition == "string" && tooltip.dontUsePosition !== "top"
                    || typeof tooltip.dontUsePosition == "object" && tooltip.dontUsePosition.indexOf("top") >= 0) {
                    tooltip.position = "top";
                }
                tooltip = this.getTooltipPosition(tooltip, iteration + 1);
            }
            else if (this.checkOverflow(tooltip).left) {
                if (typeof tooltip.dontUsePosition == "string" && tooltip.dontUsePosition !== "right"
                    || typeof tooltip.dontUsePosition == "object" && tooltip.dontUsePosition.indexOf("right") >= 0) {
                    tooltip.position = "right";
                }
                tooltip = this.getTooltipPosition(tooltip, iteration + 1);
            }
            else if (this.checkOverflow(tooltip).right) {
                if (typeof tooltip.dontUsePosition == "string" && tooltip.dontUsePosition !== "left"
                    || typeof tooltip.dontUsePosition == "object" && tooltip.dontUsePosition.indexOf("left") >= 0) {
                    tooltip.position = "left";
                }
                tooltip = this.getTooltipPosition(tooltip, iteration + 1);
            }
        }
        return tooltip;
    }
    checkOverflow(tooltip) {
        var overflow = {};
        overflow.left = tooltip.coordinates.x + tooltip.arrowSize + tooltip.gap <= 0;
        overflow.right = tooltip.coordinates.x + this.getElDimension(tooltip.element).width + tooltip.arrowSize + tooltip.gap > window.innerWidth;
        overflow.top = tooltip.coordinates.y <= 0;
        overflow.bottom = tooltip.coordinates.y + this.getElDimension(tooltip.element).height + tooltip.arrowSize + tooltip.gap > window.innerHeight;
        return overflow;
    }
    showTooltip(tooltip) {
        //console.log(`[show] ${tooltip.label}`)
        tooltip.element.style.display = "block";
        tooltip = this.getTooltipPosition(tooltip);
        tooltip.element.style.left = `${tooltip.coordinates.x}px`;
        tooltip.element.style.top = `${tooltip.coordinates.y}px`;
        //console.log(tooltip);
        this.renderArrow(tooltip);
        clearTimeout(tooltip.animTimeout);
        tooltip.animTimeout = window.setTimeout(() => {
            tooltip.element.style.opacity = "1";
        }, 10);
    }
    hideTooltip(tooltip) {
        //console.log(`[hide] ${tooltip.label}`)
        clearTimeout(tooltip.animTimeout);
        tooltip.element.style.opacity = "0";
        tooltip.animTimeout = window.setTimeout(() => {
            tooltip.element.style.display = "none";
        }, tooltip.animationDuration);
    }
}
new Zepter_V2_Tooltips();
//# sourceMappingURL=Tooltips.js.map